"use client";

import React, { useState, useEffect } from "react";
import { Quote } from "lucide-react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious, type CarouselApi } from "@/components/ui/carousel";
import { Card, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const testimonials = [{
  quote: "Un accompagnement exceptionnel du début à la fin. L'équipe a su identifier nos besoins énergétiques avec une précision remarquable.",
  name: "Jean Dupont",
  role: "Directeur Immobilier",
  location: "Paris, France"
}, {
  quote: "Grâce à leur expertise en maîtrise d'œuvre, notre projet a été livré dans les temps et sans dépassement de budget. Une rigueur exemplaire.",
  name: "Sophie Martin",
  role: "Architecte DPLG",
  location: "Lyon, France"
}, {
  quote: "L'audit énergétique réalisé a mis en lumière des économies potentielles que nous n'avions jamais envisagées. Un investissement très rentable.",
  name: "Marc Weber",
  role: "Gestionnaire de Copropriété",
  location: "Strasbourg, France"
}, {
  quote: "Une assistance à maîtrise d'ouvrage précieuse. Leur vision technique et leur réactivité ont été des atouts majeurs pour notre chantier.",
  name: "Claire Fontaine",
  role: "Promoteur Immobilier",
  location: "Bordeaux, France"
}, {
  quote: "Professionnalisme, écoute et efficacité. Je recommande vivement leurs services pour toute mission d'AMO ou d'audit.",
  name: "Lucas Bernard",
  role: "Investisseur Privé",
  location: "Nantes, France"
}];
export default function Temoignages() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  const [api, setApi] = useState<CarouselApi>();
  const [current, setCurrent] = useState(0);
  const [count, setCount] = useState(0);
  useEffect(() => {
    if (!api) return;
    setCount(api.scrollSnapList().length);
    setCurrent(api.selectedScrollSnap());
    api.on("select", () => {
      setCurrent(api.selectedScrollSnap());
    });
  }, [api]);
  return;
}